export default {
  "content": "<g clip-path=\"url(#icon_star_filled_svg__a)\"><path fill-rule=\"evenodd\" d=\"M3.685 16a.994.994 0 01-.598-.205 1.084 1.084 0 01-.38-1.135l1.157-4.5-3.49-2.945A1.095 1.095 0 01.06 6.03a1 1 0 01.913-.735l4.487-.24L7.055.68A1 1 0 018 0a.995.995 0 01.945.68l1.605 4.375 4.487.24a1.03 1.03 0 01.912.735 1.098 1.098 0 01-.329 1.16l-3.49 2.94 1.162 4.5a1.088 1.088 0 01-.384 1.135.995.995 0 01-1.146.035l-3.775-2.535-3.749 2.56a.995.995 0 01-.553.175z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_star_filled_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};